module.exports = __webpack_public_path__ + "img/ps-8.129ce86f.jpg";